import React from "react";

const CircularProgressBar = ({ progress = 75, size = 18 }) => {
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div
      className="circular-progress-bar"
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 18 18"
      >
        <defs>
          <linearGradient
            id="progressGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop
              offset="29.74%"
              stopColor="#7C4DFF"
            />
            <stop
              offset="86.78%"
              stopColor="#1783FF"
            />
          </linearGradient>
        </defs>

        {/* Background circle */}
        <path
          className="circle-background"
          d="M9 9
                    m -8, 0
                    a 8 8 0 0 1 16 0
                    a 8 8 0 0 1 -16 0"
          fill="none"
          stroke="#eee"
          strokeWidth="2"
        />

        {/* Progress circle */}
        <path
          className="circle-progress"
          d="M9 9
                    m -8, 0
                    a 8 8 0 0 1 16 0
                    a 8 8 0 0 1 -16 0"
          fill="none"
          stroke="url(#progressGradient)"
          strokeWidth="2"
          strokeDasharray="50"
          strokeDashoffset={50 - clampedProgress / 2}
        />
      </svg>
    </div>
  );
};

export default CircularProgressBar;
